import api from "@/apis/ProviderAPI";
import Crud from "./crud-base";
var crud = new Crud("Provider", api);

const state = {
  ...crud.state,
  _config: {
    field: {
      key: "AccountObjectID",
      code: "AccountObjectCode",
      name: "AccountObjectName",
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: import.meta.env.PROD,
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
